import React, { useState } from 'react';

import { Checkbox, FormControlLabel } from '@mui/material';
import Brightness5Icon from '@mui/icons-material/Brightness5';
import Brightness7Icon from '@mui/icons-material/Brightness7';

import { corporations } from '../game/corporations';
import styled from 'styled-components';
import CorporationCard from '../components/CorporationCard';

const Home = () => {
  const [darkMode, setDarkMode] = useState(false);

  return (
    <Container className={darkMode ? 'dark' : null}>
      <header>
        <h1>Terraforming Mars</h1>
        <h2>Select a Corporation</h2>
        <div id="DarkModeGroup" className="input-group">
          <FormControlLabel
            checked={darkMode}
            onChange={() => setDarkMode(!darkMode)}
            control={
              <Checkbox
                icon={<Brightness5Icon />}
                checkedIcon={<Brightness7Icon />}
              />
            }
            label="Dark Mode"
            labelPlacement="start"
            sx={{ color: darkMode ? 'white' : 'black' }}
          />
        </div>
      </header>

      <CorporationGrid>
        {corporations.map((corporation, index) => (
          <CorporationCard
            key={index}
            corporation={corporation}
            darkMode={darkMode}
          />
        ))}
      </CorporationGrid>
      <Footer>
        <p>Tool created by Lloyd Grubham &copy;{new Date().getFullYear()}</p>
      </Footer>
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  background: linear-gradient(to bottom right, red, #bf953f, firebrick);
  max-width: 100dvw;
  min-height: 100dvh;
  padding: 12px 24px 56px 24px;
  color: white;
  transition: all 0.1s ease;

  #DarkModeGroup {
    position: absolute;
    top: 12px;
    right: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    label {
      margin-right: 8px;
    }
  }

  h1,
  h2 {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    text-shadow: 3px 3px 2px rgba(0, 0, 0, 0.7);
    text-transform: uppercase;
    font-weight: 900;
  }
  h1 {
    font-size: 3rem;
    margin-bottom: 8px;
  }
  &.dark {
    background: linear-gradient(to bottom right, #333, black, #333);

    h1,
    h2 {
      color: firebrick;
    }
  }
`;

const CorporationGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 18px;

  .corp-card:last-child {
    grid-column: 2;
  }
`;

const Footer = styled.footer`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 8px;
  background-color: #111;
  color: white;
  text-align: center;
  font-size: 0.8rem;
`;

export default Home;
